<template>
	<div>
		<div class="actDiv">
			<label>水表地址</label>
			<a-input placeholder="水表地址" v-model="paramModel.meterAddr" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<label>给水号</label>
			<a-input placeholder="给水号" v-model="paramModel.apId" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<label>册本号</label>
			<a-input placeholder="册本号,支持模糊查询" v-model="paramModel.bookNum" style="width:10rem; margin: 0 0.425rem;font-size: 0.6875rem;" />
			<a-button  size="small"  icon="search" @click="doQuery">查找</a-button>
			<a-button  size="small"  icon="download" @click="exportIt" style="margin-left: 0.425rem;" :loading="exportLoading">导出</a-button>
		</div>
		<vxe-table  align="center" :data="dataList"  border max-height="500"  ref="mTable" show-overflow="title" size="mini"
						  resizable highlight-hover-row :loading="loading"  row-id="id">
			<vxe-table-column title="所属小区" field="NeighborId"    :formatter="getTheNeighborName"></vxe-table-column>
			<vxe-table-column title="房间号" field="customerNum"></vxe-table-column>
			<vxe-table-column title="给水号" field="APID"></vxe-table-column>
			<vxe-table-column title="册本号" field="book_num"></vxe-table-column>
			<vxe-table-column title="水表类型" field="out_type" :formatter="getTheMeterTypeName"  width="85"></vxe-table-column>
			<vxe-table-column title="集中器地址" field="GPRSAddr"></vxe-table-column>
			<vxe-table-column title="采集器地址" field="CollectorAddr"></vxe-table-column>
			<vxe-table-column title="水表地址" field="MeterAddr"></vxe-table-column>
			<vxe-table-column title="水表状态" field="MeterState" :formatter="getMeterState" ></vxe-table-column>
			<vxe-table-column title="抄表时间" field="readtime" :formatter="getTimeFormatter" ></vxe-table-column>
			<vxe-table-column title="抄表读数" field="readdata"  ></vxe-table-column>
		</vxe-table>
		<div style="float: right; margin-top: 1rem;" >
			<a-pagination :current="paramModel.pageNum"  showQuickJumper :show-total="total => `共 ${total} 条`"
				 :pageSize="paramModel.pageSize" :total="paramModel.totalRecords" @change="pageChangeHandler"/>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loading:false,
				exportLoading:false,
				neighborList:[],
				dataList:[],
				paramModel:{
					meterAddr:null,
					apId:null,
					pageNum: 1,
					pageSize: 10,
					totalRecords:0,
					bookNum:null,
				}
			}
		},
		methods: {
			exportIt(){
				this.exportLoading = true;
				let url = this.Api.getLastUrl(this.Api.EXPORT_ALL_FAIL_METER_URL);
				this.Api.fetchPostFile(url,this.paramModel).then((res)=>{
					this.exportLoading = false;
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = '所有故障表.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					this.exportLoading = false;
					console.log(error);
				});
			},
			getMeterState({cellValue}){
				return this.Config.getValueByNameFromList(cellValue,this.Config.getMeterStateList());
			},
			getTimeFormatter({cellValue}){
				if(cellValue == null){
					return "";
				}else{
					let date = new Date(cellValue);
					return this.Config.formatDate(date);
				}
			},
			getTheNeighborName({cellValue}){
				let result = '';
				for(var i =0 ;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(cellValue == item.pId){
						result = item.neighborName;
						break;
					}
				}
				return result;
			},
			doQuery(){
				this.paramModel.pageNum = 1;
				this.paramModel.pageSize  = 10;
				this.queryData();
			},
			queryData(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.QUERY_ALL_FAIL_METER_URL);
				this.Api.fetchPostWithForm(url,this.paramModel).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.dataList = result.content;
						this.paramModel.totalRecords = result.recordTotal;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			pageChangeHandler(pageNo,pageSize){
				this.paramModel.pageNum = pageNo;
				this.paramModel.pageSize = pageSize;
				this.queryData();
			},
			getTheMeterTypeName({cellValue}){
				let result = null;
				switch (cellValue){
					case '0':{
						result = '室内普通表';
					}
					break;
					case '1':{
						result = '室外普通表';
					}
					break;
					case '2':{
						result = '室内无线表';
					}
					break;
					case '3':{
						result = '室外无线表';
					}
					break;
					default:{
						result = "有线表";
					}
					break;
				}
				return result;
			},
			queryNeighbors:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
						this.queryData();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
		},
		created(){
			this.queryNeighbors();
		},
		computed: {
			check4Wh:function(){
				let user = this.Config.getUserLocal();
				if(user.wcId == 37){
					return true;
				}else{
					return false;
				}
			},
		},
	}
</script>

<style>
</style>
